// removed by extract-text-webpack-plugin
module.exports = {"root":"homzAj-"};


/*****************
 ** WEBPACK FOOTER
 ** ./~/seek-style-guide/react/Accessibility/ScreenReaderSkipTarget.less
 ** module id = 712
 ** module chunks = 0
 **/